module.exports = __webpack_public_path__ + "static/media/def.bf723e74.docx";